module.exports = __webpack_public_path__ + "web/static/img/yeelight.c5c896b4.png";